<p-toast 
  [style]="{marginTop: '40px'}"
  position="top-right"
  [life]="5000"
  [showTransformOptions]="'translateX(100%)'"
  [hideTransformOptions]="'translateX(100%)'">
</p-toast>